import { ILearningResourceCategory, IPage } from 'marketing-site/@types/generated/contentful'
import { getAssignedVariations } from 'marketing-site/lib/abTests'
import getLocaleCodeAndPathFromUri from 'marketing-site/lib/getLocaleAndPathFromUri'
import getPageByPath from 'marketing-site/lib/getPageByPath'
import { getResourceCategories } from 'marketing-site/lib/learnDirectory'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import Page from 'marketing-site/src/components/common/Page'
import { IAssignedVariations } from 'marketing-site/src/components/context/AssignedVariationsContext'
import { LearnDirectoryContextProvider } from 'marketing-site/src/components/context/LearnDirectoryContext'
import { RESOURCES_SLUG } from 'marketing-site/src/library/utils/constants/slugs'
import { GetServerSideProps } from 'next'
import React from 'react'

export interface IProps {
  page: IPage
  assignedVariations: IAssignedVariations
  categories: ILearningResourceCategory[]
}

const addBiggerPropToField = (field: any) => {
  if (field?.fields) {
    field.fields.asBiggerCard = true
  }
}

const addBiggerPropToBodyComponents = (page: IPage) => {
  const {
    fields: { bodyContent = [] },
  } = page
  bodyContent.forEach((field) => {
    addBiggerPropToField(field)
  })

  return page
}

export default function LearnDirectory(props: IProps) {
  const { page, categories } = props

  return (
    <EntryMarker entry={page}>
      <LearnDirectoryContextProvider {...{ categories }}>
        <Page page={addBiggerPropToBodyComponents(page)} />
      </LearnDirectoryContextProvider>
    </EntryMarker>
  )
}

export const getServerSideProps: GetServerSideProps<IProps> = async function ({
  req,
  resolvedUrl,
}) {
  const page = (await getPageByPath(RESOURCES_SLUG)) as IPage
  const { locale } = await getLocaleCodeAndPathFromUri(resolvedUrl.split('/'))

  const categories = (await getResourceCategories(locale)) || []

  const assignedVariations = await getAssignedVariations(req, page)

  return {
    props: {
      page,
      assignedVariations,
      categories,
    },
  }
}
